import { Layout, Tag } from '@loadsmart/miranda-react'

export type ShipmentIdentifiersProps = {
  identifiers?: Array<string>
}

export function ShipmentIdentifiers({ identifiers }: ShipmentIdentifiersProps) {
  const hasIdentifiers = Array.isArray(identifiers) && identifiers.length > 0
  if (!hasIdentifiers) return null

  return (
    <Layout.Group gap="spacing-2">
      {identifiers.map(identifier => (
        <Tag key={identifier}>{identifier}</Tag>
      ))}
    </Layout.Group>
  )
}
